import { EmailTypeEnum, IScheduledEmailSettings } from '@/types/email.types';

export const defaultEmailSettings: IScheduledEmailSettings = {
  showAddCalendar: true,
  showStartTime: true,
  icsSettings: { customTitle: { base: '', changed: '' }, customDescription: { base: '', changed: '' } },
};

export const defaultEmailTimezone = 'America/Los_Angeles';

export const NameFirstInSubject = [
  EmailTypeEnum.session_reminder,
  EmailTypeEnum.session_live,
  EmailTypeEnum.session_ended,
];
